import React, { useState } from "react";
import { saveHomepageSingleColumnSection } from "../../api/api";
import { useGlobalData } from '../../context/GlobalDataContext';

const createRow = () => ({ title: "", content: "" });

function RowControls({ onAdd, onRemove, canRemove }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px", justifyContent: "flex-end" }}>
      <button type="button" onClick={onAdd}>Add Row</button>
      <button type="button" onClick={onRemove} disabled={!canRemove}>Remove</button>
    </div>
  );
}


function HomepageSingleColumnAdminPanel() {
  const { homepageSingleColumn = [], loading, fetchHomepageSingleColumn } = useGlobalData();
  const [items, setItems] = useState([createRow()]);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  // loading now comes from context
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('darkMode') === 'true');

  React.useEffect(() => {
    const syncDarkMode = () => setDarkMode(localStorage.getItem('darkMode') === 'true');
    window.addEventListener('storage', syncDarkMode);
    window.addEventListener('darkModeChanged', syncDarkMode);
    return () => {
      window.removeEventListener('storage', syncDarkMode);
      window.removeEventListener('darkModeChanged', syncDarkMode);
    };
  }, []);

    React.useEffect(() => {
    if (!homepageSingleColumn?.length) {
      fetchHomepageSingleColumn();
    }
  }, [homepageSingleColumn?.length, fetchHomepageSingleColumn]);

  // Sync items with context
  React.useEffect(() => {
    if (homepageSingleColumn && homepageSingleColumn.length > 0) {
      setItems(homepageSingleColumn.map(item => ({
        title: item.title || "",
        content: item.content || ""
      })));
    } else {
      setItems([createRow()]);
    }
  }, [homepageSingleColumn]);

  const updateRow = (index, field, value) => {
    setItems((current) => current.map((item, itemIndex) => (
      itemIndex === index ? { ...item, [field]: value } : item
    )));
  };

  const addRow = () => {
    setItems((current) => [...current, createRow()]);
  };

  const removeRow = (index) => {
    setItems((current) => {
      const nextItems = current.filter((_, itemIndex) => itemIndex !== index);
      return nextItems.length ? nextItems : [createRow()];
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage("");
    setError("");
    try {
      await saveHomepageSingleColumnSection({
        items: items
          .map((item) => ({
            title: item.title.trim(),
            content: item.content.trim()
          }))
          .filter((item) => item.title || item.content)
      });
      setMessage("Homepage section save ho gaya.");
      await fetchHomepageSingleColumn(); // Refresh data after save
    } catch (submitError) {
      setError(submitError.response?.data?.error || submitError.message || "Unable to save homepage section");
    }
  };

  // Role check for superadmin only
  const role = localStorage.getItem('role');
  if (role !== 'superadmin') {
    return <div style={{ color: 'red', textAlign: 'center', marginTop: '2rem' }}>Access denied: Superadmin only</div>;
  }

  return (
    <div
      className={`resource-admin-panel resource-admin-panel--amber${darkMode ? ' dark-mode' : ''}`}
      style={{
        backgroundColor: darkMode ? '#232836' : '#fff8e1',
        padding: '20px',
        borderRadius: '8px',
        marginBottom: '30px',
        border: `2px solid ${darkMode ? '#fbbf24' : '#f59e0b'}`
      }}
    >
      <h2 style={{ color: darkMode ? '#fbbf24' : '#92400e', marginTop: 0 }}>Homepage Single Column Admin Panel</h2>
      <p style={{ color: darkMode ? '#b0b8c9' : '#4b5563', marginBottom: '16px' }}>Yaha add kiya gaya data homepage me ThreeTableSection ke niche show hoga.</p>

      <form
        onSubmit={handleSubmit}
        style={{
          backgroundColor: darkMode ? '#181c24' : 'white',
          padding: '15px',
          borderRadius: '5px',
          marginBottom: '20px'
        }}
      >
        <div style={{ marginTop: '12px' }}>
          {items.map((row, index) => (
            <div
              key={`homepage-single-row-${index}`}
              style={{ display: 'grid', gridTemplateColumns: '1fr 1.4fr auto', gap: '12px', marginBottom: '12px' }}
            >
              <input
                value={row.title}
                onChange={(event) => updateRow(index, 'title', event.target.value)}
                placeholder="Bold Title"
                style={{ background: darkMode ? '#232836' : undefined, color: darkMode ? '#fff' : undefined }}
              />
              <textarea
                value={row.content}
                onChange={(event) => updateRow(index, 'content', event.target.value)}
                placeholder="Normal content"
                style={{ minHeight: '90px', background: darkMode ? '#232836' : undefined, color: darkMode ? '#fff' : undefined }}
              />
              <RowControls onAdd={addRow} onRemove={() => removeRow(index)} canRemove={items.length > 1} />
            </div>
          ))}
        </div>

        {message && <div style={{ marginTop: '16px', padding: '12px', borderRadius: '6px', backgroundColor: darkMode ? '#1a2e22' : '#e8f5e9', color: darkMode ? '#7ee787' : '#2e7d32' }}>{message}</div>}
        {error && <div style={{ marginTop: '16px', padding: '12px', borderRadius: '6px', backgroundColor: darkMode ? '#2e1a1a' : '#ffebee', color: darkMode ? '#ff7b72' : '#c62828' }}>{error}</div>}

        <button
          type="submit"
          style={{
            width: '100%',
            marginTop: '18px',
            padding: '12px',
            backgroundColor: darkMode ? '#fbbf24' : '#d97706',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontWeight: 'bold',
            cursor: 'pointer'
          }}
        >
          Save Homepage Section
        </button>
      </form>

      {loading && <p>Loading homepage section...</p>}
    </div>
  );
}

export default HomepageSingleColumnAdminPanel;